import { useContext } from "react";

import {
  COMPLAINANT_ID,
  COMPLAINANT_INFO,
} from "../../utils/complaintsConstants";
import { QuejaReclamoContext } from "../QuejaReclamoContext/QuejaReclamoContext";
import {
  ButtonContainer,
  GrayText,
  MainButton,
  MessageContainer,
} from "./CreateComplainantRegisterStyles";

function CreateComplainantRegister(props) {
  const { onFinished, caseNumber } = props;
  const [, updateComplainantId, , updateComplainantInfo] =
    useContext<any>(QuejaReclamoContext);
  const onComplainClear = () => {
    updateComplainantId(COMPLAINANT_ID);
    updateComplainantInfo(COMPLAINANT_INFO);
    onFinished();
  };
  return (
    <MessageContainer>
      <div>
        <h1>¡Su caso fue registrado con éxito!</h1>
        <h3>{`Número de caso: ${caseNumber}`}</h3>
        <ButtonContainer>
          <MainButton onClick={onComplainClear}>¡Entendido!</MainButton>
        </ButtonContainer>
        <div className="gray">
          <GrayText>Plazo máximo según el caso</GrayText>
          <GrayText>Queja: No existe una fecha establecida.</GrayText>
          <GrayText>Reclamo: 15 días hábiles</GrayText>

          <GrayText>
            Para mayor información contactarte con el equipo de Atención de
            Servicio al Cliente (ATC):
          </GrayText>
          <GrayText>
            981 029 652 - 994 169 535 / atencion.cliente@talma.com.pe
          </GrayText>
          <GrayText> Muchas gracias.</GrayText>
        </div>
      </div>
    </MessageContainer>
  );
}

export default CreateComplainantRegister;
